export default {
    bindings: {
        transactions: '=',
    },
    controller: 'refundHistoryController',
    template: require('../views/refund.history.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/components/refund.history.component.js